import { jwtDecode } from 'jwt-decode';

interface JwtPayload {
  sub: string; // email is typically in the 'sub' field
  exp: number;
  iat: number;
}

export const getUserEmailFromToken = (): string | null => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      return null;
    }

    const decoded = jwtDecode<JwtPayload>(token);
    return decoded.sub || null;
  } catch (error) {
    console.error('Error decoding JWT token:', error);
    return null;
  }
};
